import type { SelectOption } from 'ui/select/select';

import type { TableColumnsDto } from 'cadenza/ui/base-table/model/table-columns-dto';
import {
  type AnimationSettingResult,
  AnimationSettingsDialog,
  type View
} from 'cadenza/conditions/actions/animation-settings-dialog';
import {
  TableSliderAnimationPreview
} from 'cadenza/conditions/table-slider-condition/table-slider-animation-preview';
import type {
  WorkbookTableConditionApi
} from 'cadenza/api-client/workbook-conditions/workbook-table-condition-api';

import i18n from './table-slider-animation-settings-dialog.properties';

const COMPONENT_NAME = 'd-table-slider-animation-settings-dialog';

export interface TableSliderAnimationSettingsDialogOptions {
  isWorkbook: boolean;
  affectedViews: View[];
  rangeStart: SelectOption;
  rangeEnd: SelectOption;
  selectedStart: SelectOption;
  maxFrames: number;
  conditionApi: WorkbookTableConditionApi;
  tableColumnsDef: TableColumnsDto;
}

export class TableSliderAnimationSettingsDialog extends AnimationSettingsDialog {

  readonly #options: TableSliderAnimationSettingsDialogOptions;
  readonly #preview: TableSliderAnimationPreview;

  constructor (options: TableSliderAnimationSettingsDialogOptions) {
    super(options.isWorkbook, options.affectedViews);
    this.#options = options;
    this.#preview = this._createPreview();
    this.setLoading(this.#preview.dataLoadingPromise, { label: i18n('loadingData') });
  }

  createSpecificContent (): HTMLElement[] {
    return [ this.#preview ];
  }

  _createPreview (): TableSliderAnimationPreview {
    return new TableSliderAnimationPreview(
      this.#options.selectedStart,
      this.#options.rangeEnd,
      this.#options.maxFrames,
      this.#options.conditionApi,
      this.#options.tableColumnsDef);
  }

  override onSubmit (event: SubmitEvent) {
    const result: AnimationSettingResult = {
      type: 'table',
      viewId: this.selectedViewId,
      rangeStart: this.#preview.startIndex,
      rangeEnd: this.#preview.endIndex,
      sliderRangeStart: this.#options.rangeStart,
      sliderRangeEnd: this.#options.rangeEnd
    };
    this.close(result);
  }

}

customElements.define(COMPONENT_NAME, TableSliderAnimationSettingsDialog);
